const showPlural = (length: number) => {
  return length === 1 ? '' : 's';
};

export default showPlural;
